const pageStyles = {
  alignItems: 'center',
  background: 'linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%)',
  display: 'flex',
  justifyContent: 'center',
  minHeight: '60vh',
  padding: '4rem 1rem',
};

const cardStyles = {
  backgroundColor: '#fff',
  border: '1px solid #e5edf8',
  borderRadius: '1rem',
  boxShadow: '0 18px 45px rgba(15, 23, 42, 0.12)',
  maxWidth: '42rem',
  padding: '3rem 2rem',
  textAlign: 'center',
};

const eyebrowStyles = {
  color: '#1976d2',
  fontSize: '0.875rem',
  fontWeight: 700,
  letterSpacing: '0.08em',
  margin: '0 0 0.75rem',
  textTransform: 'uppercase',
};

const titleStyles = {
  color: '#1f2937',
  fontSize: 'clamp(2rem, 5vw, 3rem)',
  fontWeight: 700,
  lineHeight: 1.15,
  margin: '0 0 1rem',
};

const descriptionStyles = {
  color: '#4b5563',
  fontSize: '1.05rem',
  lineHeight: 1.6,
  margin: '0 auto 2rem',
  maxWidth: '32rem',
};

const linkStyles = {
  display: 'inline-block',
  padding: '0.85rem 1.5rem',
  borderRadius: '999px',
  backgroundColor: '#1976d2',
  color: '#fff',
  fontWeight: 600,
  textDecoration: 'none',
  boxShadow: '0 10px 24px rgba(25, 118, 210, 0.28)',
};

const NotFoundView = ({ staticContext }) => {
  if (staticContext) {
    staticContext.statusCode = 404;
  }

  return (
    <main style={pageStyles}>
      <section aria-labelledby='not-found-title' style={cardStyles}>
        <p style={eyebrowStyles}>Error 404</p>
        <h1 id='not-found-title' style={titleStyles}>Página no encontrada</h1>
        <p style={descriptionStyles}>
          La página que buscás no existe, fue movida o el enlace ya no está disponible.
          Podés volver al inicio para continuar navegando.
        </p>
        <a href='/' style={linkStyles}>
          Volver al inicio
        </a>
      </section>
    </main>
  );
};

export default NotFoundView;
